<template>
  <main class="internet_direct_pop">
    <div
      data-v-05ab5af4=""
      class="modal_wrap bottom_modal"
      autoestimation=""
      :class="{ on: isOpen }"
    >
      <div class="modal_inner" @click.self="$emit('close')">
        <div class="modal">
          <div class="safe_phone_pop">
            <div class="ttl_area">
              <h1>{{ nickname }}님!</h1>
              <p>
                가입시 인증하신 번호로 안내전화가 갈 예정입니다.<br />
                동의를 원하시면 아래 신청하기를 눌러주세요!
              </p>
            </div>

            <div class="p_sec_item">
              <dl>
                <dt>선택 상품</dt>
                <dd>
                  <ul class="type_basic">
                    <li>
                      <input
                        type="radio"
                        name="telecom"
                        id="telecom_01"
                        v-model="telecomValue"
                        value="SKT"
                      />
                      <label for="telecom_01"><span>SKT</span></label>
                    </li>
                    <li>
                      <input
                        type="radio"
                        name="telecom"
                        id="telecom_02"
                        v-model="telecomValue"
                        value="KT"
                      />
                      <label for="telecom_02"><span>KT</span></label>
                    </li>
                    <li>
                      <input
                        type="radio"
                        name="telecom"
                        id="telecom_03"
                        v-model="telecomValue"
                        value="LGU+"
                      />
                      <label for="telecom_03"><span>LGU+</span></label>
                    </li>
                    <li>
                      <input
                        type="radio"
                        name="telecom"
                        id="telecom_04"
                        v-model="telecomValue"
                        value="추천희망"
                      />
                      <label for="telecom_04"><span>추천희망</span></label>
                    </li>
                  </ul>
                </dd>
              </dl>
            </div>
            <div class="p_sec">
              <dl>
                <dt>연락 가능 시간</dt>
                <dd>
                  <ul class="type_basic">
                    <li>
                      <input
                        type="radio"
                        name="time"
                        id="time_01"
                        v-model="timeValue"
                        value="모든시간"
                      />
                      <label for="time_01"><span>모든시간</span></label>
                    </li>
                    <li>
                      <input
                        type="radio"
                        name="time"
                        id="time_02"
                        v-model="timeValue"
                        value="10:00 ~ 12:00"
                      />
                      <label for="time_02"><span>10:00 ~ 12:00</span></label>
                    </li>
                    <li>
                      <input
                        type="radio"
                        name="time"
                        id="time_03"
                        v-model="timeValue"
                        value="12:00 ~ 15:00"
                      />
                      <label for="time_03"><span>12:00 ~ 15:00</span></label>
                    </li>
                    <li>
                      <input
                        type="radio"
                        name="time"
                        id="time_04"
                        v-model="timeValue"
                        value="15:00 ~ 19:00"
                      />
                      <label for="time_04"><span>15:00 ~ 19:00</span></label>
                    </li>
                  </ul>
                </dd>
              </dl>
            </div>
            <div class="btm_btn">
              <div class="btn_wrap">
                <button class="btn" @click.stop.prevent="agreeSend">
                  동의 후 신청하기
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'sendModal',
  props: {
    nickname: String,
  },
  components: {},
  data() {
    return {
      isOpen: false,
      timeValue: '모든시간',
      telecomValue: 'SKT',
    };
  },
  computed: {},
  methods: {
    close() {
      this.$emit('close');
    },
    agreeSend() {
      this.$emit('agreeSend');
    },
  },
};
</script>
